import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { reduce, sortBy } from 'lodash-es';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { Link } from 'site-modules/shared/components/link/link';
import { Image } from 'site-modules/shared/components/image/image';
import { SOURCES, getStaticImageUrl } from 'client/utils/image-helpers';
import { NO_VEHICLE_GRAY_IMAGE_SEDAN } from 'site-modules/shared/constants/images';

import './state-card-vehicles-content.scss';

function StateCardVehicle({
  vehicleName = '',
  image = null,
  link = null,
  topPosition = 1,
  isBestSeller = false,
  priceRange = '',
}) {
  const errorImage = getStaticImageUrl(NO_VEHICLE_GRAY_IMAGE_SEDAN);

  return (
    <div
      className={classnames('state-card-vehicle my-0_5 px-0_5', { 'best-seller-card py-0_5 rounded': isBestSeller })}
    >
      <p className="size-16 text-primary-darker mb-0">
        <span className="text-gray-darker fw-bold pe-0_25">{topPosition}.</span>
        {link ? <Link to={link}>{vehicleName}</Link> : vehicleName}
      </p>
      {isBestSeller && (
        <Row className="align-items-center">
          <Col xs={3}>
            <Image
              imageId={image}
              source={SOURCES.DAM}
              className="img-fluid rounded"
              alt={vehicleName}
              width={300}
              errorImage={errorImage}
            />
          </Col>
          <Col xs={9}>
            <span className="d-block text-gray size-14">MSRP</span>
            <span className="d-block fw-bold size-16">{priceRange}</span>
          </Col>
        </Row>
      )}
    </div>
  );
}

StateCardVehicle.propTypes = {
  vehicleName: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  topPosition: PropTypes.number,
  isBestSeller: PropTypes.bool,
  priceRange: PropTypes.string,
};

export function StateCardVehiclesContent({ stateData = null }) {
  if (!stateData) return null;

  const stateVehiclesData = reduce(
    stateData,
    (result, value, key) => {
      if (/topSeller\d$/.test(key)) {
        const topPosition = +key.split('topSeller')[1];
        const isBestSeller = topPosition === 1;
        return isBestSeller
          ? [
              ...result,
              {
                topPosition,
                vehicleName: stateData.bestSeller,
                link: stateData.bestSellerURL,
                image: stateData.bestSellerImage,
                priceRange: stateData.bestSellerMsrpRange,
                isBestSeller: true,
              },
            ]
          : [...result, { topPosition, vehicleName: value, link: stateData[`topSeller${topPosition}URL`] }];
      }
      return result;
    },
    []
  );

  return (
    <div className="state-card-vehicles-content vehicles-list">
      {sortBy(stateVehiclesData, ['topPosition']).map(vehicle => (
        <StateCardVehicle key={vehicle.topPosition} {...vehicle} />
      ))}
    </div>
  );
}

StateCardVehiclesContent.propTypes = {
  stateData: PropTypes.shape({}),
};
